import { Link } from 'react-router-dom';
import { Tag } from 'antd';
import { useSelector } from 'react-redux';
import {
  getFriendlyTime,
  getPriceText,
} from '@zorba-shared/core/Services/textService';
import _ from 'lodash';
import { DEAL_SUBMISSION_STATUS_OPTIONS } from '../DealSubmissionFilter/constants';
import {
  buildBuyerPageUrl,
  buildDealSubmissionPageUrl,
} from '../../../../services/urlBuilderService';

const HUBSPOT_STAGE_TO_NAME_MAP = {
  "default": "Default",
  "129624089": "Draft",
  "129570901": "Missing Info",
  "129601399": "Pending UW",
  "129601400": "Pending Buyer Approval",
  "129601401": "Pending Seller Approval",
  "129624090": "Pending Agreement",
  "129601402": "Pending Inspection",
  "129596063": "Closing",
  "129606957": "Closed Won",
  "129596066": "Rejected by Seller",
  "129596064": "Rejected by Underwriting",
  "129596065": "Rejected by Buyer",
  'pending_uw': 'Pending UW',
  'awaiting_buyer_approval': `Awaiting buyer's approval`,
  'pending_buyer_approval': `Awaiting buyer's approval`,
}

export const getTableColumns = (agents = []) => [
  {
    title: 'last updated',
    key: 'updatedAt',
    dataIndex: 'updatedAt',
    render: (updatedAt) => getFriendlyTime(updatedAt),
    sorter: (a, b) => (a.updatedAt > b.createdAt ? 1 : -1),
  },
  {
    title: 'Address',
    key: 'address',
    render: ({ address, _id }) => (
      <Link
        className="buyer-name"
        to={buildDealSubmissionPageUrl({ dealSubmission: { _id } })}
        target="_blank"
        rel="noopener noreferrer"
      >
        {address.formattedAddress}
      </Link>
    ),
  },
  {
    title: 'Seller',
    key: 'seller',
    render: ({ organization, submittedBy, isCreatedByAutomation, source }) => {
      let displayName;

      if (isCreatedByAutomation && source === 'Investor Lift') {
        displayName = 'Automation (Investor Lift)';
      } else if (isCreatedByAutomation && source === 'Email') {
        displayName = 'Automation (Gmail)';
      } else {
        displayName = submittedBy?.name || organization?.name;
      }

      return (
        <Link
          className="buyer-name"
          to={buildBuyerPageUrl({ userDetails: { _id: submittedBy?._id } })}
        >
          {displayName}
        </Link>
      );
    },
  },
  {
    title: 'Matching Buyer',
    key: 'linkedBuyer',
    render: ({ matches }) => {
      const sortedMatches = matches?.length
        ? matches.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
        : [];
      const userLink =
        sortedMatches?.length > 0 &&
          sortedMatches[0].organization?.members?.length > 0
          ? sortedMatches[0]?.organization.members[0]
          : null;
      return (
        <Tag>
          <Link
            className="buyer-name"
            to={buildBuyerPageUrl({
              userDetails: { _id: userLink },
            })}
          >
            {sortedMatches[0]?.organization?.name}
          </Link>
        </Tag>
      );
    },
  },
    {
    title: 'Hubspot Status',
    key: 'hubspotStatus',
    render: ({  hubspotDealStage }) => (
      <Tag className={`zorba-tag`}>
        {HUBSPOT_STAGE_TO_NAME_MAP[hubspotDealStage] || ''}
      </Tag>
    ),
  },
  {
    title: 'Associated Agent',
    key: 'associatedAgent',
    render: ({ hubspotDealOwner }) => {
      const agent = agents.find(agent => agent.hubspotAgentId === hubspotDealOwner);
      return agent ? agent.name : '';
    },
  },
  {
    title: 'Source',
    key: 'kind',
    render: ({ kind }) => (
      <Tag>{kind === 'pre-deal' ? 'Pre-Lock' : 'Wholesale'}</Tag>
    ),
  },

  {
    title: 'Status',
    key: 'status',
    render: ({ step }) => (
      <Tag className={`zorba-tag ${step}`}>
        {
          DEAL_SUBMISSION_STATUS_OPTIONS.find((option) => option.value === step)
            ?.label
        }
      </Tag>
    ),
  },
  {
    title: 'Matches',
    key: 'matches',
    render: ({ powerBuyerMatches }) => {
      const matches = powerBuyerMatches?.filter((item) => item.status) || [];

      return matches.length;
    },
  },
  {
    title: 'Offer requests',
    key: 'offers',
    render: ({ matches }) => matches?.length,
  },
  {
    title: 'ARV',
    key: 'arv',
    render: ({ underwriting }) => getPriceText(underwriting?.arv),
  },
  {
    title: 'Inspection mode',
    key: 'inspectionMode',
    render: (dealSubmission) => {
      const finalOffer = _.last(
        dealSubmission.events.filter((e) => e.kind === 'buyer_final_offer'),
      );

      const lastOfferEvent =
        finalOffer ||
        _.last(dealSubmission.events.filter((event) => event.kind === 'offer'));

      return lastOfferEvent?.inspectionMode || '';
    },
  },
  {
    title: 'Did finish underwriting?',
    key: 'didFinishUnderwriting',
    render: ({ underwriting }) => (underwriting?.arv ? 'Yes' : ''),
  },
  {
    title: 'Zillow URL',
    key: 'zillowUrl',
    render: (dealSubmission) => (
      <a
        className="buyer-name"
        href={`https://zillow.com${dealSubmission?.zillowData?.hdpUrl}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        Zillow
      </a>
    ),
  },
  {
    title: 'Photos URL',
    key: 'photosUrl',
    render: (dealSubmission) => (
      <a
        className="buyer-name"
        href={`https://buy.getzorba.com/deal/photos/${dealSubmission._id}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        Photos
      </a>
    ),
  },
];
